import React from "react";
import { ReserveFieldUsers } from "@/features/reserve/components/ReserveFieldUsers/ReserveFieldUsers";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";
import { useAuthenticated } from "@gettactic/hooks";

export interface ReserveFormMeetingRoomUsersSelectorProps {
  defaultUsers?: string[];
}

export const ReserveFormMeetingRoomUsersSelector: React.FC<
  ReserveFormMeetingRoomUsersSelectorProps
> = ({ defaultUsers }) => {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();

  const { form } = useReserveForm();
  return (
    <ReserveFieldUsers
      form={form}
      single={false}
      defaultValue={defaultUsers || []}
      filterValues={(option) => option.value !== authenticatedUser?.user?.id}
      errors={form.formState.errors}
    />
  );
};
